import React from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import PrivacyPolicy from "./PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Header />
      <MainComponent type='privacy' />
      <PrivacyPolicy />
      <Footer />
      <FooterDown />
    </div>
  );
};

export default PrivacyPolicyPage;
